import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class ProductEstimateAffixMixin extends Vue {
  protected estimateWidth = '300px';

  private ratio = 0.3333;

  get enableAffix() {
    return this.$vuetify.breakpoint.mdAndUp;
  }

  protected mounted() {
    this.calcEstimateWidth();
  }

  protected async onResize() {
    await this.calcEstimateWidth();
  }

  private async calcEstimateWidth() {
    const affix = document.getElementById('affix-reference') as HTMLElement;

    if (affix) {
      return (this.estimateWidth =
        Math.round(
          affix.getBoundingClientRect().width - this.$vuetify.theme['grid-padding'][this.$vuetify.breakpoint.name],
        ) + 'px');
    }

    this.estimateWidth =
      Math.round(
        this.$vuetify.theme.width[this.$vuetify.breakpoint.name] * this.ratio -
          this.$vuetify.theme['grid-padding'][this.$vuetify.breakpoint.name],
      ) + 'px';
  }
}
